import { CaretDown, CaretUp } from '@phosphor-icons/react';
import { ReactNode, useState } from 'react';
import styled from 'styled-components';

import { Button } from '../../primitives';

interface CardProps {
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  $width?: string;
  $height?: string;
  options?: {
    isCollapsible?: boolean;
    $maxHeight?: string;
    $cardBodyPadding?: string;
    $cardBodyHeight?: string;
  };
}

const UICard = styled.div<{ $width: string; $height: string }>`
  min-width: 100px;
  width: ${props => props.$width};
  height: ${props => props.$height};
  border-radius: 10px;
  background-color: white;
  line-height: 24px;
  border: 1px solid #d5d9e2;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  font-weight: bold;
  border-bottom: 1px solid #d5d9e2;
`;

const CardBody = styled.div<{ $maxHeight: string; $cardBodyHeight: string; $cardBodyPadding?: string }>`
  padding: ${props => {
    return props.$cardBodyPadding !== undefined ? props.$cardBodyPadding : '1em';
  }};
  max-height: ${props => props.$maxHeight};
  height: ${props => props.$cardBodyHeight};
`;

const CardFooter = styled.div`
  padding: 0.5em;
  border-top: 1px solid #d5d9e2;
`;

export const Card: React.FC<CardProps> = ({ title, children, footer, $width, $height, options }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <UICard $width={$width ?? 'auto'} $height={$height ?? 'auto'}>
      <CardHeader>
        {title}
        {options?.isCollapsible && (
          <Button variant='outlined' onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <CaretUp /> : <CaretDown />}
          </Button>
        )}
      </CardHeader>
      {isExpanded && (
        <CardBody
          $cardBodyPadding={options?.$cardBodyPadding}
          $cardBodyHeight={options?.$cardBodyHeight ?? 'auto'}
          $maxHeight={options?.$maxHeight ?? '100%'}
        >
          {children}
        </CardBody>
      )}
      {isExpanded && footer && <CardFooter>{footer}</CardFooter>}
    </UICard>
  );
};
